module.exports = __webpack_public_path__ + "b7d8d9d48956fc44db43595b872ddabe.pdf";